import axios from "axios";

const API = axios.create({
  baseURL: "https://www.frendrops.in/api/",
});

export default API;